// Word to use when generating text for specimens.
// should be sorted by length
// JSON.stringify(Wordlist.sort((a,b) => (a.length >= b.length) ? 1 : -1)) can help.
export const WORDLIST = [
    'it',
    'if',
    'is',
    'in',
    'to',
    'or',
    'of',
    'so',
    'he',
    'up',
    'no',
    'on',
    'oh',
    'do',
    'go',
    'we',
    'me',
    'em',
    'its',
    'all',
    'art',
    'air',
    'set',
    'bat',
    'are',
    'old',
    'big',
    'but',
    'not',
    'her',
    'ink',
    'out',
    'joy',
    'top',
    'fun',
    'fog',
    'ace',
    'eye',
    'cap',
    'can',
    'age',
    'hey',
    'bad',
    'bag',
    'one',
    'any',
    'ago',
    'add',
    'few',
    'new',
    'now',
    'own',
    'left',
    'fair',
    'this',
    'ajar',
    'true',
    'quit',
    'into',
    'zest',
    'half',
    'flux',
    'best',
    'each',
    'epic',
    'taco',
    'cozy',
    'open',
    'very',
    'most',
    'pica',
    'aged',
    'good',
    'plus',
    'back',
    'zero',
    'news',
    'away',
    'draw',
    'arch',
    'name',
    'here',
    'both',
    'home',
    'down',
    'aioli',
    'final',
    'grits',
    'fluff',
    'vital',
    'their',
    'jolly',
    'until',
    'false',
    'toast',
    'third',
    'tasty',
    'clear',
    'click',
    'level',
    'zilch',
    'front',
    'forty',
    'table',
    'fjord',
    'salsa',
    'tools',
    'large',
    'three',
    'fresh',
    'unite',
    'heart',
    'there',
    'enter',
    'swift',
    'quiet',
    'feign',
    'igloo',
    'think',
    'salad',
    'gloss',
    'coast',
    'color',
    'spice',
    'sleep',
    'vivid',
    'eagle',
    'irony',
    'stand',
    'pizza',
    'place',
    'slope',
    'angst',
    'tweet',
    'zebra',
    'small',
    'waltz',
    'verbs',
    'black',
    'twins',
    'twice',
    'jewel',
    'times',
    'bleep',
    'every',
    'about',
    'laugh',
    'could',
    'ready',
    'count',
    'debut',
    'smart',
    'quick',
    'shade',
    'under',
    'union',
    'upper',
    'urban',
    'usage',
    'storm',
    'meter',
    'rodeo',
    'funky',
    'funny',
    'cocoa',
    'ocean',
    'prime',
    'check',
    'whisk',
    'above',
    'stamp',
    'venue',
    'kayak',
    'codex',
    'goods',
    'evoke',
    'queue',
    'theme',
    'forum',
    'smash',
    'chasm',
    'dogma',
    'human',
    'chomp',
    'comma',
    'magma',
    'flight',
    'little',
    'thirty',
    'better',
    'rotate',
    'retina',
    'office',
    'lizard',
    'status',
    'piglet',
    'series',
    'sports',
    'guitar',
    'subtle',
    'picnic',
    'poster',
    'center',
    'avatar',
    'fourth',
    'pickle',
    'colors',
    'planet',
    'coffee',
    'sunset',
    'quartz',
    'potato',
    'nature',
    'ninety',
    'splash',
    'poetry',
    'theory',
    'output',
    'aurora',
    'square',
    'phrase',
    'octave',
    'quasar',
    'source',
    'spaces',
    'indeed',
    'almost',
    'canvas',
    'adverb',
    'unique',
    'wizard',
    'orange',
    'review',
    'remote',
    'photon',
    'glamor',
    'groovy',
    'banana',
    'bottom',
    'rhythm',
    'magnet',
    'method',
    'almond',
    'remove',
    'markup',
    'phylum',
    'shadow',
    'bamboo',
    'emblem',
    'medium',
    'italics',
    'illicit',
    'article',
    'villain',
    'stylish',
    'giraffe',
    'lexical',
    'legible',
    'typical',
    'striped',
    'legibly',
    'correct',
    'eclipse',
    'quietly',
    'haircut',
    'feather',
    'feature',
    'natural',
    'trouble',
    'tonight',
    'written',
    'current',
    'sunrise',
    'serious',
    'elegant',
    'cursive',
    'writing',
    'teacher',
    'obelisk',
    'plateau',
    'lexicon',
    'excerpt',
    'publish',
    'vintage',
    'angular',
    'squares',
    'success',
    'granola',
    'century',
    'physics',
    'happily',
    'rubbish',
    'without',
    'unicorn',
    'capable',
    'thunder',
    'unusual',
    'echelon',
    'foundry',
    'heading',
    'halcyon',
    'volcano',
    'succeed',
    'sneezed',
    'whisper',
    'sarcasm',
    'approve',
    'uniform',
    'equinox',
    'goddess',
    'typhoon',
    'vacancy',
    'whiskey',
    'wrought',
    'volumes',
    'diamond',
    'airline',
    'account',
    'absence',
    'accused',
    'conduct',
    'combine',
    'comfort',
    'clothes',
    'consist',
    'federal',
    'improve',
    'journey',
    'justify',
    'liberty',
    'premier',
    'present',
    'victory',
    'someday',
    'wingman',
    'comment',
    'memento',
    'sinister',
    'portrait',
    'relative',
    'frontier',
    'diatribe',
    'thirteen',
    'biscuits',
    'specific',
    'triptych',
    'scissors',
    'implicit',
    'football',
    'tectonic',
    'strategy',
    'trousers',
    'colorful',
    'theories',
    'contrast',
    'pizzeria',
    'scaffold',
    'backfire',
    'recently',
    'reaction',
    'cleverly',
    'struggle',
    'variable',
    'strength',
    'division',
    'forensic',
    'strongly',
    'daylight',
    'plethora',
    'possible',
    'industry',
    'relaxing',
    'assorted',
    'succinct',
    'ultimate',
    'fourteen',
    'rigorous',
    'passport',
    'accurate',
    'possibly',
    'absolute',
    'birthday',
    'dispatch',
    'readable',
    'audacity',
    'perceive',
    'discover',
    'eighteen',
    'universe',
    'graphics',
    'nonstick',
    'progress',
    'sprocket',
    'vacation',
    'ordinary',
    'diaspora',
    'thoughts',
    'lavender',
    'isomeric',
    'occasion',
    'darkness',
    'quadrant',
    'geodesic',
    'uniquely',
    'recorded',
    'teaspoon',
    'accuracy',
    'advanced',
    'abstract',
    'advocate',
    'convince',
    'critical',
    'daughter',
    'previous',
    'priority',
    'producer',
    'register',
    'relevant',
    'reliable',
    'question',
    'response',
    'standard',
    'sergeant',
    'surprise',
    'symbolic',
    'tomorrow',
    'together',
    'yourself',
    'unlikely',
    'umbrella',
    'prologue',
    'verbatim',
    'warranty',
    'thousand',
    'windmill',
    'suddenly',
    'barbecue',
    'suburban',
    'sideways',
    'spectrum',
    'argument',
    'wardrobe',
    'landmark',
    'specimen',
    'password',
    'sympathy',
    'backward',
    'symmetry',
    'symphony',
    'monogram',
    'commonly',
    'moonwalk',
    'literally',
    'intrinsic',
    'fifteenth',
    'fantastic',
    'particles',
    'different',
    'heuristic',
    'vis-a-vis',
    'fortnight',
    'flatbread',
    'entertain',
    'certainly',
    'identical',
    'chocolate',
    'beautiful',
    'happiness',
    'adventure',
    'dangerous',
    'president',
    'adjective',
    'pineapple',
    'secretary',
    'affection',
    'education',
    'influence',
    'wonderful',
    'packaging',
    'reservoir',
    'asteroids',
    'blueprint',
    'antipasto',
    'excellent',
    'billboard',
    'authority',
    'universal',
    'breakfast',
    'duplicate',
    'sculpture',
    'groceries',
    'vicarious',
    'turquoise',
    'obscurity',
    'one-tenth',
    'gradually',
    'notorious',
    'foolproof',
    'hopefully',
    'cranberry',
    'copyright',
    'afternoon',
    'enchilada',
    'periscope',
    'important',
    'otherwise',
    'lagniappe',
    'telephone',
    'axiomatic',
    'proximity',
    'accordion',
    'chemistry',
    'crescendo',
    'clockwise',
    'pepperoni',
    'uppercase',
    'paragraph',
    'chromatic',
    'beginning',
    'frequency',
    'amplitude',
    'quicksand',
    'hatchback',
    'shipwreck',
    'ephemeral',
    'dimension',
    'catchword',
    'megahertz',
    'something',
    'pneumatic',
    'permanent',
    'sourdough',
    'immediate',
    'newspaper',
    'sometimes',
    'meanwhile',
    'ambiguous',
    'symbolism',
    'knowledge',
    'microcosm',
    'component',
    'wholesome',
    'pseudonym',
    'anonymous',
    'somewhere',
    'basketball',
    'characters',
    'literature',
    'depression',
    'perfection',
    'technology',
    'appreciate',
    'watermelon',
    'strawberry',
    'retirement',
    'television',
    'silhouette',
    'punishment',
    'confidence',
    'renovation',
    'restaurant',
    'adaptation',
    'generation',
    'helicopter',
    'stalactite',
    'scientific',
    'infinitely',
    'distinctly',
    'fiberglass',
    'fortuitous',
    'beneficial',
    'top-secret',
    'letterhead',
    'helicopter',
    'especially',
    'air-cooled',
    'difference',
    'post-haste',
    'friendship',
    'individual',
    'stalagmite',
    'two-thirds',
    'chartreuse',
    'free-range',
    'equestrian',
    'buttermilk',
    'equivalent',
    'astonished',
    'full-blown',
    'acceptable',
    'auspicious',
    'designated',
    'half-baked',
    'parametric',
    'journalism',
    'everything',
    'circumflex',
    'impossible',
    'juxtaposed',
    'palindrome',
    'accomplish',
    'photograph',
    'everywhere',
    'hyphenated',
    'tax-exempt',
    'widescreen',
    'high-speed',
    'underscore',
    'cheesecake',
    'statistical',
    'distinctive',
    'all-weather',
    'streamlined',
    'thunderclap',
    'typographic',
    'hand-picked',
    'combination',
    'immediately',
    'denominator',
    'aerodynamic',
    'home-brewed',
    'prehistoric',
    'singularity',
    'educational',
    'figuratively',
    'freeze-dried',
    'introduction',
    'polysyllabic',
    'ambidextrous',
    'abbreviation',
    'middle-class',
    'alliteration',
    'headquarters',
    'nomenclature',
    'contemporary',
    'monosyllabic',
    'quadrilateral',
    'cross-country',
    'extraordinary',
    'old-fashioned',
    'inconceivable',
    'high-fidelity',
    'skateboarding',
    'correspondent',
    'approximately',
    'mind-boggling',
    'unconditional',
    'classification',
    'implementation',
    'aforementioned',
    'thermodynamics',
    'self-propelled',
    'transportation',
    'cinematographer',
    'two-dimensional',
    'acknowledgement',
    'cross-reference',
    'straightforward',
    'transcontinental',
    'electromagnetism',
    'interdisciplinary',
] as const;
